<button mat-raised-button class="button-chart" (click)="openChart()"><mat-icon>multiline_chart</mat-icon></button>
